import type { State } from '../reducer.tsx';

export const isAdmin = (state: State) => state.context.isAdmin;
export const getLocale = (state: State) => state.context.locale;
